/* Rhody Reviews api/v1 -- widget domain. PURE EXTRACTION from lib/api.ts (gate-prep split); no behavior change. */
import { request } from './_http';

/* Widget config (GET/PUT /widget). */
export interface WidgetConfig {
  id: string;
  layout: 'carousel' | 'grid' | 'badge';
  theme: 'light' | 'dark';
  min_rating: number; // 1-5
  source: 'google' | 'all';
  show_overall: boolean;
  auto_rotate: boolean;
  verified_only: boolean;
  powered_by: boolean;
  embed_key: string;
  // Grid layout controls (ignored by single/carousel).
  grid_cols: number;   // 3 | 4 | 5
  grid_rows: number;   // 4 | 5 | 6 | 7
  grid_scroll: 'fixed' | 'continuous';
  [k: string]: unknown;
}
export interface WidgetResponse {
  client_id: string;
  widget: WidgetConfig;
}
export type WidgetUpdate = Partial<
  Pick<
    WidgetConfig,
    | 'layout'
    | 'theme'
    | 'source'
    | 'min_rating'
    | 'show_overall'
    | 'auto_rotate'
    | 'verified_only'
    | 'powered_by'
    | 'grid_cols'
    | 'grid_rows'
    | 'grid_scroll'
  >
>;

/* Send-install (POST /widget/send-install). */
export interface SendInstallInput {
  to_email: string;
  to_name?: string;
  note?: string;
}
export interface SendInstallResponse {
  client_id: string;
  to_email: string;
  sent: boolean;
  delivery: 'brevo' | 'fallback';
  message_id: string | null;
  send_error: string | null;
  subject: string;
  body: string;
  embed_snippet: string;
  mailto: string;
}

export const widgetApi = {
  /* ----- Widget config ----- */
  getWidget(signal?: AbortSignal): Promise<WidgetResponse> {
    return request<WidgetResponse>('/api/v1/widget', { signal });
  },
  updateWidget(patch: WidgetUpdate): Promise<WidgetResponse> {
    return request<WidgetResponse>('/api/v1/widget', { method: 'PUT', body: patch });
  },
  sendWidgetInstall(input: SendInstallInput): Promise<SendInstallResponse> {
    return request<SendInstallResponse>('/api/v1/widget/send-install', {
      method: 'POST',
      body: input,
    });
  },
};
